import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Money } from '../../../core/model/money';

@Component({
    selector: 'app-month-rent',
    templateUrl: './month-rent.component.html',
    styleUrls: ['./month-rent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MonthRentComponent implements OnInit {
  constructor() {}

  @Input() rent: Money;

  ngOnInit() {
    if (!this.rent) this.rent = new Money(null, null);
  }
}
